<template>
  <div>
    <div class="relative flex items-center featured-container">
      <div class="container pax20 flex justify-center items-center-l tc">
        <div class="featured-image-container absolute absolute--fill z-0">
          <img
            :data-srcset="require('~/assets/images/about-cover.jpg').srcSet"
            data-src="~assets/images/about-cover.jpg"
            class="image-cover lazyload"
          />
        </div>
        <div class="absolute absolute--fill z-1 bg-linear-gradient"></div>
        <div class="white z-2 pa2 pl0-l pr4-l mb5-l">
          <h1 class="ma0 mb4 mt4-l lh-title f1">
            {{ $t('about.heading') }}
          </h1>
          <p class="dn db-l pb3 mb4 mw7 fs-subheading">
            {{ $t('about.subheading') }}
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="container pax20">
        <div class="pv4">
          <nuxt-link :to="localePath({ name: 'index' })" class="mr1"
            ><img
              src="~/assets/icons/ic_home.svg"
              width="16"
              height="16"
              class="v-mid"
          /></nuxt-link>
          <img
            src="~/assets/icons/ic_arrow_bc.svg"
            width="6"
            height="10"
            class="mr1"
          />
          {{ $t('navigation.about') }}
        </div>
        <div class="flex-l items-center mb4 mb6-l">
          <!-- <h2 class="tc">{{ $t('about.intro.heading') }}</h2> -->
          <div class="w-100 w-50-l pr6-l">
            <p class="">{{ $t('about.intro.text1') }}</p>

            <p class="">{{ $t('about.intro.text3') }}</p>
          </div>
          <div class="w-100 w-50-l">
            <img
              :data-srcset="
                require('~/assets/images/about-present@2x.jpg').srcSet
              "
              data-src="~assets/images/about-present.jpg"
              class="lazyload"
            />
          </div>
        </div>
        <p class="tc f2 mb5">{{ $t('about.helpingHeader') }}</p>
        <div
          class="flex mb2 flex-column flex-row-l justify-around items-center mb6-l"
        >
          <img
            data-src="~assets/images/logo-koinvesticinis-fondas.svg"
            class="lazyload mb4 mb0-l"
            width="253"
            height="40"
          />
          <img
            data-src="~assets/images/logo-discontract-multi.svg"
            class="lazyload mb4 mb0-l"
            width="168"
            height="40"
          />
          <img
            data-src="~assets/images/logo-rockit.svg"
            class="lazyload mb4 mb0-l"
            width="144"
            height="30"
          />
        </div>

        <div class="image-container overflow-hidden">
          <img
            :data-srcset="require('~/assets/images/team-photo.jpg').srcSet"
            data-src="~assets/images/about-us-3.jpg"
            class="featured-image lazyload"
          />
        </div>
        <div class="container quote-container pa3 pa5-l flex-l">
          <div class="w-100 w-75-l">
            <p class="fs-subheading tl">{{ $t('about.team.text') }}</p>
          </div>
          <div class="w-100 w-25-l tr">
            <p class="flex flex-column">
              <span class="b">{{ $t('about.team.footer') }}:</span>
              <a
                class="link no-underline dim pa1"
                href="https://www.linkedin.com/in/laurynasantanavicius/"
                >Laurynas Antanavičius</a
              >
              <a
                class="link no-underline dim pa1"
                href="https://www.linkedin.com/in/gediminas-jankus/"
                >Gediminas Jankus</a
              >
              <a
                class="link no-underline dim pa1"
                href="https://www.linkedin.com/in/tautvilas/"
                >Tautvilas Mečinskas</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="bg-near-white mt5">
        <DownloadNow />
      </div>
    </div>
  </div>
</template>

<script>
import DownloadNow from '~/components/DownloadNow';

export default {
  scrollToTop: true,
  components: {
    DownloadNow,
  },
  head() {
    return {
      title: this.$t('about.title'),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$t('about.description'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('about.description'),
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('about.title'),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com${this.$route.path.replace(
            /\/?$/,
            '/'
          )}`,
        },
      ],
    };
  },
};
</script>
